import {CitizenshipOptions, EducationPhase} from './enums';
import {CommunityCollegeInfo, CurrentInstitution, HighSchoolInfo} from './education';
import {Address} from './user';

export type ISODateFormat = string;
export type NumericDateFormat = number;

export interface BaseForm {
  _id: string;
  title: string;
  firstName: string;
  lastName: string;
  educationPhase: EducationPhase;
  ineligibleCountry: boolean;
  onboardingCompletedAt?: NumericDateFormat;
  referralSource?: {
    type: string;
    createdAt: ISODateFormat;
    slug: string;
  };
}

export type NameForm = BaseForm;

export type AddressForm = BaseForm &
  Address & {
    _addressSuggestion?: AddressForm | false;
  };

export type BirthdayForm = BaseForm & {
  birthday: ISODateFormat;
  replacementAccountType: EducationPhase | null;
};

export type TransferEligibilityForm = BaseForm &
  Address & {
    _addressSuggestion?: AddressForm | false;
    currentInstitution?: CurrentInstitution;
  };

export type CurrentInstitutionForm = BaseForm &
  Address & {
    currentInstitution: CurrentInstitution;
  };

export type EducatorInstitutionForm = BaseForm & {
  institutionId: string;
};

export type HighSchoolInformationForm = BaseForm & {
  highSchoolInfo: HighSchoolInfo;
};

export type TransferInformationForm = BaseForm & {
  communityCollegeInfo: CommunityCollegeInfo;
};

export type CitizenshipForm = BaseForm &
  Pick<Address, 'country'> & {
    isUsCitizenOrResident: CitizenshipOptions | null;
    countryOfCitizenship: string;
  };

export type PellEligibilityForm = BaseForm & {
  communityCollegeInfo: Pick<CommunityCollegeInfo, 'lowIncome'>;
};

export type TransferTermForm = BaseForm & {
  communityCollegeInfo: Pick<CommunityCollegeInfo, 'transferYear' | 'transferSemester'>;
};

export type CaseloadForm = BaseForm & {
  caseload: string;
};

export type HowPlanningToUseRaiseMeForm = BaseForm & {
  howPlanningToUseRaiseMe: string[];
};

export type HowHeardRaiseMeForm = BaseForm & {
  howHeard: string;
};

export type FollowCollegesForm = HighSchoolInformationForm & {
  signupSkipFollowedCollegesStep: boolean;
  followedCollegeIds: string[];
};

export interface OnboardingActions {
  deleteStudent: (id: string, reason: string, redirectPath: string) => void;
}

export type PeerReferralForm = BaseForm & {
  referralEmails: string[];
};

export type StudentConnectionForm = BaseForm & {
  connectedStudentFirstName: string;
  connectedStudentLastName: string;
  connectedStudentMobile?: string;
  connectedStudentEmail: string;
};

export enum MobileFormState {
  INITIAL,
  CODE_SENT,
  VERIFIED,
}

export type MobileNumberForm = BaseForm & {
  mobile: string | null;
  verificationCode: string;
  mobileVerified: boolean;
  mobileFormState: MobileFormState;
};

export type UnverifiedMobileNumberForm = BaseForm & {
  mobile: string | null;
  mobileFormState: MobileFormState;
};

export interface ParentEmailForm {
  parentEmail: string;
}

export type CongratsForm = Record<string, never>;
